.betWrapper {
  display: grid;
  grid-template-columns: 1fr 25px;
  padding: 8px;
  border-top: 1px solid var(--ogm-mavericks);
  border-bottom: 1px solid var(--ogm-mavericks);
  z-index: var(--cxy-z-index-internal-base);
}
.betWrapper:first-of-type {
  border-top: none;
}
.betWrapper .name {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--ogm-timberwolves);
  padding-bottom: 5px;
}
.betWrapper .spreadValue {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--ogm-bucks);
  padding-bottom: 5px;
  margin-left: 5px;
}
.betWrapper .subeventName {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--ogm-black);
  padding-bottom: 3px;
}
.betWrapper .marketName {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--cxy-color-brand);
  padding-bottom: 3px;
}
.betWrapper .closeBet {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  cursor: pointer;
}
.betWrapper.disabled {
  opacity: 0.5;
}
